import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPermissions } from "../rbac/hasAccess";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import moment from "moment";
import { toast } from "react-toastify";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { AddButton, SearchToggleButton } from "../../../utils/Custom/Button";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import AppConfirmBox from "../../../utils/commonComponent/appConfirmBox";
import { AutoCompletes, DateInput } from "../../../utils/Custom/custominput";
import { getFormattedDates } from "../../../utils/utils";
import { notifiy } from "../../notification/Notification";

const fields = [{ value: "userName", label: "User" }];
// Status options for approve/reject dropdown
const statusOptions = [
  { value: "0", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "-1", label: "Rejected" }
];

  // Helper function to get status badge color
  const getStatusBadge = (approveStatus) => {
    if (approveStatus == 0) return "Pending";
    if (approveStatus == -1) return "Rejected";
    return "Approved";
  };

const AttendanceRegularizationList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editAttendanceRegularization/${row.id}`);
  const userId = localStorage.getItem("id");
  const type = localStorage.getItem("type");
  const [selectedRows, setSelectedRows] = useState([]);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [dialogProps, setDialogProps] = React.useState({});
  const [fromDate, setFromDate] = useState(sessionStorage.getItem("fromDate") || "");
  const [toDate, setToDate] = useState(sessionStorage.getItem("toDate") || "");
  const [selectEmployee, setselectEmployee] = useState(sessionStorage.getItem("selectEmployee") || "");
  const [approvalStatus, setApprovalStatus] = useState(sessionStorage.getItem("approvalStatus") || "0"); 
  const [employeeList, setemployeeList] = useState([]);
  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };
  const handleSelectAll = () => {
    if (selectedRows.length === templateList.length) {
      setSelectedRows([]); // unselect all
    } else {
      setSelectedRows(templateList.map((row) => row.id)); // select all
    }
  };

  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [templateList, setTemplateList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  
  const handleDelete = async (id) => {
    const url = BASE_URL;
    const idString = (Array.isArray(id) ? id : [id]).join(",");
    const confirmed = window.confirm("Are you sure you want to delete this ?");
    if (!confirmed) return;

    try {
      await axiosWithToken.post(url + "dynamic", {
        query: `delete from attendanceRegularization WHERE id IN (${idString});`,
      });
      toast("Deleted Successfully!");
      fetchData();
    } catch (error) {
      console.log("err", error);
    }
  };

  const handleReject = (rows) => {
    setDialogProps({
      title: "Do you really want to reject?",
      showRemark: false,
      confirmText: "Reject",
      confirmColor: "error",
      onConfirm: () => rejectAttendance(rows),
    });
    setOpenConfirm(true);
  };

  const rejectAttendance = async (rows) => {
    setOpenConfirm(false);
    const url = BASE_URL;
    const rowsArray = Array.isArray(rows) ? rows : [rows];
    const idString = rowsArray.map((row) => row.id).join(",");

    try {
      await axiosWithToken.post(url + "dynamic", {
        query: `UPDATE attendanceRegularization SET approveStatus = -1 WHERE id IN (${idString});`,
      });
      toast("Rejected Successfully!");
      const notifications = rowsArray.map((row) => ({
        _from: userId,
        _to: row.userId,
        body: `Your attendance punch request has been rejected by HR.`,
      }));
      notifiy(
        notifications.length === 1 ? notifications[0] : notifications,
        () => {
          console.log("Reject attendance notification sent");
        }
      );
      fetchData();
    } catch (error) {
      console.log("err", error);
    }
  };

  const handleApprove = (rows) => {
    setDialogProps({
      title: "Do you really want to approve?",
      showRemark: false,
      confirmText: "Approve",
      confirmColor: "success",
      onConfirm: () => approveAttendance(rows),
    });
    setOpenConfirm(true);
  };

  const approveAttendance = async (rows) => {
    setOpenConfirm(false); // Close confirm popup
    const url = BASE_URL;
    const userId = localStorage.getItem("id");
    const rowsArray = Array.isArray(rows) ? rows : [rows];
    const idString = rowsArray.map((row) => row.id).join(",");
    
    try {
      // 1️⃣ Update approveStatus
      await axiosWithToken.post(url + "dynamic", {
        query: `UPDATE attendanceRegularization SET approveStatus = ${userId} WHERE id IN (${idString});`,
      });

      // 2️⃣ Get current user location
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

          for (const row of rowsArray) {
            const punchIn = moment(row.punchInDateTime);
            const punchOut = moment(row.punchOutDateTime);

            const dayCount = punchOut.diff(punchIn, "days") + 1;

            for (let i = 0; i < dayCount; i++) {
              // Clone original times but increment date
              const checkinDateTime = punchIn.clone().add(i, "days");
              const checkoutDateTime = punchOut
                .clone()
                .add(i, "days")
                .subtract(dayCount - 1, "days");

              const checkInPayload = {
                userId: row.userId,
                employeeId: row.employeeId,
                checkinLat: latitude,
                checkinLang: longitude,
                checkinDatetime: checkinDateTime.format("YYYY-MM-DD HH:mm:ss"),
                checkoutDatetime: checkoutDateTime.format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
              };

              await axiosWithToken.post(url + "attendance", checkInPayload);
            }
          }

          toast("Approved Successfully!");
          window.location.reload();
        },
        (error) => {
          console.log("Geolocation error:", error);
          window.location.reload();
        }
      );

      const notifications = rowsArray.map((row) => ({
        _from: userId,
        _to: row.userId,
        body: `Your attendance punch request has been approved by HR.`,
      }));
      notifiy(
        notifications.length === 1 ? notifications[0] : notifications,
        () => {
          console.log("Reject attendance notification sent");
        }
      );
    } catch (error) {
      console.log("err", error);
    }
  };

  const getQuery = (count = false) => {
      let whereConditions = "";
      let pagination_settings = "";
  
      // Base condition for non-admin users
      const isAdminOrApprover = ["1", "8"].includes(type) || permissions.approve || permissions.allAccess;
      if (!isAdminOrApprover) {
        whereConditions = `WHERE attendanceRegularization.userId = ${userId}`;
      }
  
      // When NOT searched - show only pending (default behavior)
      if (!fromDate) {
        const defaultCondition = `attendanceRegularization.approveStatus = 0`;
        whereConditions = whereConditions
          ? `${whereConditions} AND ${defaultCondition}`
          : `WHERE ${defaultCondition}`;
      } else {
        // When SEARCHED - apply the selected status filter
        let statusCondition = "";
        
        // Get the actual value - handle both string and object cases
        const statusValue = typeof approvalStatus === 'object' ? approvalStatus.value : approvalStatus;
        
        
        if (statusValue === "0") {
          statusCondition = `attendanceRegularization.approveStatus = 0`;
        } else if (statusValue === "-1") {
          statusCondition = `attendanceRegularization.approveStatus = -1`;
        } else if (statusValue === "approved") {
          statusCondition = `attendanceRegularization.approveStatus NOT IN (0, -1)`;
        }
  
        if (statusCondition) {
          whereConditions = whereConditions
            ? `${whereConditions} AND ${statusCondition}`
            : `WHERE ${statusCondition}`;
        }
      }
  
      // Employee filter
      if (selectEmployee) {
        const employeeCondition = `attendanceRegularization.userId = ${selectEmployee}`;
        whereConditions = whereConditions
          ? `${whereConditions} AND ${employeeCondition}`
          : `WHERE ${employeeCondition}`;
      }
  
      // Search by field filter
      if (searchBy && searchKey.trim()) {
        const colName = {
          userName: "u.userName",
        }[searchBy];
  
        const searchCondition = `LOWER(${colName}) LIKE LOWER('%${searchKey}%')`;
        whereConditions = whereConditions
          ? `${whereConditions} AND ${searchCondition}`
          : `WHERE ${searchCondition}`;
      }
  
      // Date range filter
      if (fromDate && toDate) {
        const { from, to } = getFormattedDates(fromDate, toDate);
        const dateCondition = `DATE(attendanceRegularization.punchInDateTime) BETWEEN '${from}' AND '${to}'`;
        whereConditions = whereConditions
          ? `${whereConditions} AND ${dateCondition}`
          : `WHERE ${dateCondition}`;
      }
  
      // Count query
      if (count) {
        return `SELECT COUNT(*) AS no_of_rows FROM attendanceRegularization LEFT JOIN users u ON attendanceRegularization.userId = u.id ${whereConditions};`;
      }
  
      // Pagination
      const offset = currentPage * rowsPerPage;
      pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${offset}`;
  
      // Main query
      return `SELECT attendanceRegularization.*, u.userName, e.employeesCode AS employeesCode,e.name AS employeeName, u.employeeId FROM attendanceRegularization LEFT JOIN users u ON attendanceRegularization.userId = u.id LEFT JOIN employees e ON u.employeeId=e.id ${whereConditions} ORDER BY attendanceRegularization.id DESC ${pagination_settings};`;
    };

  const fetchData = async () => {
    try {
      const countQuery = getQuery(true);
      const countResult = await fetchQuery(countQuery);
      setTotalRecords(countResult[0]?.no_of_rows || 0);

      const query = getQuery();
      const result = await fetchQuery(query);
      setTemplateList(result);
    } catch (error) {
      console.error("Error fetching template data:", error);
    }
  };

  const fetchemployee = async () => {
    try {
      const empQuery = "SELECT u.id, u.userName, u.employeeId, e.employeesCode, e.name AS employeeName FROM users u LEFT JOIN employees e ON u.employeeId = e.id WHERE u.status != -1 ORDER BY u.userName ASC;";
      const result = await fetchQuery(empQuery);
      const formatted = result.map(emp => ({
        ...emp,
        label: emp.employeesCode ? `${emp.employeeName || ""} (${emp.employeesCode})` : emp.employeeName || ""
      }));
      setemployeeList(formatted);
    } catch (error) {
      console.error("Error fetching empQuery data:", error);
    }
  };

  const handleSearch = () => {
    if (!fromDate || !toDate) {
      alert("Please select both From Date and To Date to search.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
    sessionStorage.setItem("fromDate", fromDate);
    sessionStorage.setItem("toDate", toDate);
    sessionStorage.setItem("approvalStatus", typeof approvalStatus === "object" ? approvalStatus.value : approvalStatus);
    sessionStorage.setItem("selectEmployee", selectEmployee);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("");
    setSearchKey("");
    setFromDate("");
    setToDate("");
    setApprovalStatus("0"); // Reset to Pending
    setselectEmployee("");
    fetchData();
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
    sessionStorage.removeItem("fromDate");
    sessionStorage.removeItem("toDate");
    sessionStorage.removeItem("approvalStatus");
    sessionStorage.removeItem("selectEmployee");
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    fetchemployee();
  }, [])

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  useEffect(() => {
    if (employeeList.length > 0) {
      const savedEmp = sessionStorage.getItem("selectEmployee");
      if (savedEmp) {
        const found = employeeList.find(emp => emp.id == savedEmp);
        if (found) setselectEmployee(found);
      }
    }
  }, [employeeList]);

  useEffect(() => {
    const savedStatus = sessionStorage.getItem("approvalStatus");
    if (savedStatus) {
      const found = statusOptions.find(opt => opt.value == savedStatus);
      if (found) setApprovalStatus(found);
    }
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/editAttendanceRegularization/0"
          label="Add Attendance"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      {/* STATIC SEARCH UI */}
      <div className="mt-2 border border-blue-100 rounded-xl shadow-sm p-6 pt-3 mb-4 bg-white">

        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-4">

          {/* Date From */}
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              Date From <span className="text-red-500">*</span>
            </label>
            <DateInput id="from-date" label="From Date" value={fromDate}
              onChange={(d) => {
                setFromDate(d);
                setSearched(false);
              }} />
          </div>

          {/* Date To */}
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              Date To <span className="text-red-500">*</span>
            </label>
            <DateInput id="to-date" label="To Date" value={toDate}
              onChange={(d) => {
                setToDate(d);
                setSearched(false);
              }} />
          </div>

          {/* Approval Status */}
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              Status
            </label>
            <AutoCompletes
              id="status-field"
              label={"Select Status"}
              options={statusOptions}
              value={approvalStatus}
              onChange={(e) => {
                setApprovalStatus(e);
                setSearched(false);
              }}
            />
          </div>

          {/* Employee Name */}
          {(type == 1 || type == 8 || permissions.approve) && (
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              Employee Name
            </label>
            <AutoCompletes
              id="employee-field"
              label={"Select Employee"}
              options={employeeList}
              value={selectEmployee}
              onChange={(e) => {
                setselectEmployee(e);
                setSearched(false);
              }}
              valueKey="id"
            />
          </div>
          )}

          {/* Search By Dropdown */}
          {/* <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              Search by
            </label>
            <AutoCompletes
              id="search-field"
              label={"Select field"}
              options={fields}
              value={searchBy}
              onChange={(e) => {
                setSearchBy(e);
                setSearched(false);
              }}
            />
          </div> */}
         
          {/* Search & Clear buttons */}
        <div className="flex gap-3 mt-5">
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
        </div>
        </div>
      </div>

      <br />

      {selectedRows.length > 0 &&
        (permissions.approve || permissions.allAccess) && (
          <div className="flex gap-3 mb-3">
          <button
            onClick={() =>
              handleApprove(
                templateList.filter((row) => selectedRows.includes(row.id))
              )
            }
            className="bg-green-600 text-white rounded-md px-4 py-2 hover:bg-green-700 text-md font-medium"
          >
            Multiple Approve
          </button>
            <button
              onClick={() =>
                handleReject(
                  templateList.filter((row) => selectedRows.includes(row.id))
                )
              }
              className="bg-red-600 text-white rounded-md px-4 py-2 hover:bg-red-700 text-md font-medium"
            >
              Multiple Reject
            </button>
          </div>
        )}

      <div className="w-full border rounded-md shadow mt-3">
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 text-center">
                  <input
                    type="checkbox"
                    checked={selectedRows.length === templateList.length}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="px-4 py-3 text-center">Sr. No.</th>
                <th className="px-4 py-3 text-center">User</th>
                <th className="px-4 py-3 text-center">Employees Name</th>
                <th className="px-4 py-3 text-center">PunchIn Date Time</th>
                <th className="px-4 py-3 text-center">PunchOut Date Time</th>
                <th className="px-4 py-3 text-center">Reason</th>
                <th className="px-4 py-3 text-center">Status</th>
                {(permissions.edit ||
                  permissions.approve ||
                  permissions.delete ||
                  permissions.allAccess) && (
                  <th className="px-4 py-3 text-center">Actions</th>
                )}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {templateList.length > 0 ? (
                templateList.map((row, index) => (
                  <tr
                    key={row.id}
                    // className={
                    //   row.approveStatus != 0
                    //     ? "bg-green-100 hover:bg-green-200"
                    //     : "hover:bg-gray-50"
                    // }
                  >
                    <td className="px-4 py-3 text-center">
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={() => handleSelectRow(row.id)}
                      />
                    </td>
                    <td className="px-4 py-3 text-center">
                      {currentPage * rowsPerPage + index + 1}
                    </td>
                    <td className="px-4 py-3 text-center">{row.userName}</td>
                    <td className="px-4 py-3 text-center">{row.employeeName}</td>
                    <td className="px-4 py-3 text-center">
                      {row.punchInDateTime
                        ? moment(row.punchInDateTime).format(
                            "DD/MM/YYYY hh:mm A"
                          )
                        : ""}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {row.punchOutDateTime
                        ? moment(row.punchOutDateTime).format(
                            "DD/MM/YYYY hh:mm A"
                          )
                        : ""}
                    </td>
                    <td className="px-4 py-3 text-center">{row.reason}</td>
                    <td className="px-4 py-3 text-center">
                      <span className={`px-2 py-1 rounded text-xs font-medium ${row.approveStatus == 0 ? "bg-yellow-200 text-yellow-800" :
                          row.approveStatus == -1 ? "bg-red-200 text-red-800" :
                            "bg-green-200 text-green-800"
                        }`}>
                        {getStatusBadge(row.approveStatus)}
                      </span>
                    </td>

                    {(permissions.edit ||
                      permissions.delete ||
                      permissions.approve ||
                      permissions.allAccess) && (
                      <td className="px-4 py-2 text-center">
                        <div className="flex justify-center gap-2">
                          {(permissions.approve || permissions.allAccess || type == 1 || type == 8) && (row.approveStatus == 0) && (
                              <>
                            <button
                              onClick={() => handleApprove(row)}
                              className="bg-green-600 text-white rounded-md px-3 py-1 hover:bg-green-700 text-md"
                                  title="Approve"
                            >
                              Approve
                            </button>
                                <button
                                  onClick={() => handleReject(row)}
                                  className="bg-red-600 text-white rounded-md px-3 py-1 hover:bg-red-700 text-md"
                                  title="Reject"
                                >
                                  Reject
                                </button>
                              </>
                          )}
                          {(permissions.edit || permissions.allAccess) && (
                            <button
                              onClick={() => handleEdit(row)}
                              className="text-blue-600 hover:text-blue-800"
                              title="Edit"
                            >
                              <EditIcon fontSize="small" />
                            </button>
                          )}
                          {(permissions.delete || permissions.allAccess) && (
                            <button
                              onClick={() => handleDelete(row.id)}
                              className="text-blue-600 hover:text-blue-800"
                              title="Delete"
                            >
                              <DeleteIcon fontSize="small" />
                            </button>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={permissions.edit || permissions.delete ? 6 : 5}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between gap-2 px-2 py-2 bg-blue-50 text-xs sm:text-sm border-t overflow-x-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <span>Rows Per Page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-1 py-0.5 text-xs sm:text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-gray-600 hidden sm:inline">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRecords
                )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>

      <AppConfirmBox
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        {...dialogProps}
      />
    </>
  );
};

export default AttendanceRegularizationList;
